import { Box, makeStyles } from '@material-ui/core';
import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { CONSTANTS } from '../../../core/config/constants';
import { FontSizes } from '../../../core/config/mainTheme';
import { FinValueWithYear } from '../../../generated/compat/finValueWithYear';
import { FinValueWithYearOfbigdecimal } from '../../../generated/model/finValueWithYearOfbigdecimal';
import { FinValueWithYearOfboolean } from '../../../generated/model/finValueWithYearOfboolean';
import { FinValueWithYearOfstring } from '../../../generated/model/finValueWithYearOfstring';

interface Props {
  label: string;
  consolidated?:
    | FinValueWithYear
    | FinValueWithYearOfbigdecimal
    | FinValueWithYearOfstring
    | FinValueWithYearOfboolean;
  unconsolidated?:
    | FinValueWithYear
    | FinValueWithYearOfbigdecimal
    | FinValueWithYearOfstring
    | FinValueWithYearOfboolean;
  children?: ReactNode;
}

const ContentBlockConsolidatedYearValue: React.FC<Props> = ({
  label,
  consolidated,
  unconsolidated,
  children,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const consolidatedPref =
    consolidated && unconsolidated ? t('companies:consolidation:consolidated') : '';
  const unconsolidatedPref =
    consolidated && unconsolidated ? t('companies:consolidation:unconsolidated') : '';

  return (
    <>
      <Box className={classes.label}>{label}</Box>
      {consolidated && (
        <Box
          className={classes.value}
        >{`${consolidatedPref} ${consolidated.year}: ${consolidated.value}`}</Box>
      )}
      {unconsolidated && (
        <Box
          className={classes.value}
        >{`${unconsolidatedPref} ${unconsolidated.year}: ${unconsolidated.value}`}</Box>
      )}
      {!consolidated && !unconsolidated && CONSTANTS.EMPTY_VALUE}
      {children}
    </>
  );
};
const useStyles = makeStyles((theme) => ({
  label: {
    textTransform: 'uppercase',
    fontSize: FontSizes.size.small,
    color: theme.palette.grey[500],
  },
  value: {
    fontSize: FontSizes.size.medium,
    color: theme.palette.grey[900],
  },
}));

export default ContentBlockConsolidatedYearValue;
